module.exports = __webpack_public_path__ + "assets/img/init_pos_curtain3.578a9387.png";